import { render, staticRenderFns } from "./DialogEditShipping.pug?vue&type=template&id=311c5a52&lang=pug&"
import script from "./DialogEditShipping.vue?vue&type=script&lang=js&"
export * from "./DialogEditShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports